var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#93E9C8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2824_16420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5973 15.5482C15.2737 16.7375 16.2625 17.7263 17.4518 18.4026L18.0906 17.5083C18.303 17.211 18.7039 17.1192 19.0246 17.2943C20.0406 17.8493 21.1635 18.1866 22.3348 18.2793C22.7104 18.3091 23 18.6225 23 18.9993V22.2225C23 22.5927 22.7199 22.903 22.3516 22.9409C21.9689 22.9802 21.5828 23 21.1944 23C15.0119 23 10 17.9881 10 11.8056C10 11.4172 10.0198 11.0311 10.0591 10.6484C10.097 10.28 10.4073 10 10.7776 10H14.0007C14.3775 10 14.6909 10.2896 14.7207 10.6652C14.8134 11.8365 15.1507 12.9594 15.7057 13.9754C15.8808 14.2961 15.789 14.697 15.4917 14.9094L14.5973 15.5482ZM12.7764 15.0738L14.1486 14.0936C13.7595 13.2537 13.4929 12.363 13.3564 11.4444H11.451C11.4466 11.5646 11.4444 11.6849 11.4444 11.8056C11.4444 17.1903 15.8097 21.5556 21.1944 21.5556C21.3151 21.5556 21.4354 21.5534 21.5556 21.549V19.6436C20.637 19.5071 19.7463 19.2405 18.9064 18.8514L17.9262 20.2236C17.5297 20.0696 17.1468 19.8883 16.7798 19.6822L16.7378 19.6583C15.3226 18.8535 14.1465 17.6774 13.3417 16.2622L13.3178 16.2202C13.1117 15.8532 12.9304 15.4703 12.7764 15.0738Z",
    fill: "#101010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2824_16420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandline);
export default __webpack_public_path__ + "static/media/Landline.86b661610e9a70c4270480bf9d2c43d0.svg";
export { ForwardRef as ReactComponent };